module.exports = __webpack_public_path__ + "static/publish_mobile-b0074b7e6d34f06b465864765f3ebf48.webp";